import jQuery from "jquery";
jQuery(document).ready(function ($) {
    let $shareBtn = $('.dp_field_ex_share_url_button');

    if($shareBtn.length) {
        $('.dp_field_ex_share_url_button').on("click", function(e){
            e.preventDefault();
            let $el = $(this);
            /* Get the text field */
            var dummy = document.createElement('input'),
                text = window.location.href;

            document.body.appendChild(dummy);
            dummy.value = text;
            dummy.select();
            dummy.setSelectionRange(0, 99999);
            document.execCommand('copy');
            document.body.removeChild(dummy);

            $el.find(".ex_share_text_url_button").html('Ok!');

            setTimeout(function () {
                $el.find(".ex_share_text_url_button").html($el.data('text'));
            }, 2000);
            return false;
        });
    }

    function dp_field_ex_share_url_button(el) {
        /* Get the text field */
        var dummy = document.createElement('input'),
            text = window.location.href;

        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        dummy.setSelectionRange(0, 99999);
        document.execCommand('copy');
        document.body.removeChild(dummy);

        el.getElementsByClassName("ex_share_text_url_button")[0].innerHTML = 'Ok!';

        setTimeout(function () {
            el.getElementsByClassName("ex_share_text_url_button")[0].innerHTML = el.getAttribute('data-text');
        }, 2000)
    }

});
